import { render, staticRenderFns } from "./PurchaseOrderParts.vue?vue&type=template&id=69606fa2&scoped=true"
import script from "./PurchaseOrderParts.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderParts.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderParts.vue?vue&type=style&index=0&id=69606fa2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69606fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69606fa2')) {
      api.createRecord('69606fa2', component.options)
    } else {
      api.reload('69606fa2', component.options)
    }
    module.hot.accept("./PurchaseOrderParts.vue?vue&type=template&id=69606fa2&scoped=true", function () {
      api.rerender('69606fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderParts.vue"
export default component.exports